<template>
    <div class="loading-view">
        <div class="loader" />
    </div>
</template>

<style lang="scss">
.loading-view {
    --size: 100px;
    --thickness: 8px;
    --color: #eee;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    .loader {
        width: var(--size);
        height: var(--size);
        border: var(--thickness) solid var(--color);
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite !important;
    }
}


@keyframes rotation {
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
}
</style>
